export const COLLECTION_ITEMS_TABLE_COLUMN_CLASSNAMES = {
  checkbox: "w-6",
  item: "z-[1] w-[120px] grow-[2] pr-2",
  price: "w-[130px] grow",
  offer: "w-[130px] grow",
  last: "w-[110px] grow",
  rarity: "w-[70px] grow",
  owner: "w-[70px] grow",
  listed: "w-[70px] grow",
}
